import { cn } from '@repo/ui/lib/utils'

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-muted', className)}
      data-slot="skeleton"
      {...props}
    data-sentry-component="Skeleton" data-sentry-source-file="skeleton.tsx" />
  )
}

export { Skeleton }
